import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";

const buildQueryParams = (params) => {
  return Object.entries(params)
    .filter(([key, value]) => value !== undefined && value !== null)
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");
};

const fetchMilestonePerformance = async ({ queryKey }) => {

  const [, testSuiteResultId, testStepId] = queryKey;

  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");

  const user = JSON.parse(userDetails);

  const queryParams = buildQueryParams({
    action: "getMilestonePerformance",
    companyid: user.companyid,
    testsuiteresultid: testSuiteResultId,
    teststepid: testStepId
  });

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?${queryParams}`
  );

  return response.data;
};

const useMilestonePerformanceQuery = (
  testSuiteResultId,
  testStepId,
  options = {}
) => {

  return useQuery({
    queryKey: ["milestonePerformance", testSuiteResultId, testStepId],
    queryFn: fetchMilestonePerformance,
    enabled: Boolean(testSuiteResultId && testStepId),
    staleTime: 1000 * 60 * 5,
    ...options
  });

};

export default useMilestonePerformanceQuery;